import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import PropTypes from "prop-types";
import Form1 from "./Form1";
import Form2 from "./Form2";
import Form3 from "./Form3";
import Form4 from "./Form4";
import Review from './Review';
import RegistrationSteps from './RegistrationSteps';
import TestContainer from '../../containers/UserCourse/TestContainer';
import $ from 'jquery';


class OnBoarding extends Component {

    state = {
        formSubmited: 1,
        scrollClass: '',
        formClass: '',
        collapsedForms: [],
        courseUser: null
    };
    
    componentDidMount = (props) => {
        if(this.props.location.pathname === '/on-boarding'){
            if(this.props.courseUser[0]){
                if(this.props.courseUser[0].id){
                    let profile = this.props.profile;
                    
                    profile.CourseUser = this.props.courseUser;
                    this.props.updateProfile(profile, this.props.user.id);
                    this.props.history.push('/onboarding/' + this.props.courseUser[0].id)
                }else{
                    this.props.history.push('/onboarding/' + this.props.profile.CourseUser[0].id)
                }
            }else{
                this.props.history.push('/onboarding/' + this.props.profile.CourseUser[0].id)
            }
            
            
        }else{
            this.getCourseUser(this.props);
            this.props.hideLoader();
        }
        window.addEventListener('scroll', this.handleScroll);
    }
    
    componentWillUpdate = (props) => {
        if(this.props.location.pathname === '/on-boarding'){
            if(this.props.courseUser[0]){
                if(this.props.courseUser[0].id){
                    let profile = this.props.profile;
                    profile.CourseUser = this.props.courseUser;
                    this.props.updateProfile(profile, this.props.user.id);
                    this.props.history.push('/onboarding/' + this.props.courseUser[0].id)
                }else if(this.props.profile.CourseUser[0]){
                    this.props.history.push('/onboarding/' + this.props.profile.CourseUser[0].id)
                }
            }else{
                this.props.history.push('/onboarding/' + this.props.profile.CourseUser[0].id)
            }
        }else{
            this.props.hideLoader();
            let cu = null;
        
            if(props.profile.CourseUser){
                cu = props.profile.CourseUser.filter(c => c.id === this.props.match.params.courseUserId)[0] || null;
            }
            
            if((cu !== this.state.courseUser && cu)){
                this.getCourseUser(props);
            }
        }
    }
    
    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handleScroll);
    }
    
    getCourseUser = (props) => {
        let cu = null;
        
        if(props.profile.CourseUser){
            cu = props.profile.CourseUser.filter(c => c.id === props.match.params.courseUserId)[0] || null;
        }else{
            //this.props.getCourseUserForProfile(props.match.params.courseUserId, props.user.id);
        }
        this.setState({courseUser: cu});
    }
    
    collapseForm = (number) => {
        if(this.state.collapsedForms.indexOf(number) === -1){
            this.setState({collapsedForms: this.state.collapsedForms.concat(number)});
        }
    }
    
    clearCollapseForms = () => {
        this.setState({collapsedForms: []})
    }
    
    toggleCollapse = (number) => {
        if(this.state.collapsedForms.indexOf(number) === -1){
            this.setState({collapsedForms: this.state.collapsedForms.concat(number)});
        }else{
            this.state.collapsedForms.splice(this.state.collapsedForms.indexOf(number), 1);
            this.setState({collapsedForms: this.state.collapsedForms});
        }
    }
    
    handleScroll = (event) => {
        let scrollTop = event.target.scrollTop;
        if(this.state.scrollClass === '' && $(window).scrollTop() > 75){
        
            this.setState({
              scrollClass: 'scrolled',
              formClass: 'form-scrolled'
            });
        }else if(this.state.scrollClass !== '' && $(window).scrollTop() < 75){
            this.setState({
              scrollClass: '',
              formClass: ''
            });
        }
        
        
        var bodyH = $(".wrapper").height()-$(window).height();
        var v = $(window).scrollTop();
        var p = (v/bodyH)*100;
        $(".steps .active .progressBarWizard").css("width",p+"%");
        if(p>99){
            $(".steps .active").addClass("activeBg");
        }else{
            $(".steps .active").removeClass("activeBg");
        }
    }

    setPrevStep = () => {
        let profile = {id: this.props.profile.id, onboardingStep: this.props.profile.onboardingStep - 1};
        this.props.updateProfile(profile, this.props.user.id);
        $(window).scrollTop(0);
    }
    
    setSpecificStep = (number) => {
        if(number > 0 && number < 7 && number < this.props.profile.onboardingStep){
            let profile = {id: this.props.profile.id, onboardingStep: number};
            this.props.updateProfile(profile, this.props.user.id);
            $(window).scrollTop(0);
        }
    }

    componentWillMount = () => {
        this.props.getProfile(this.props.profile.id, this.props.user.id);
    }

    moveToTest = () => {
        let profile = {id: this.props.profile.id, onboardingStep: this.props.profile.onboardingStep + 1};
        this.props.updateProfile(profile, this.props.user.id);
        $(window).scrollTop(0);
    }

    renderHelpVideos = () => {
        return (
            <div>
                <br /><br />
                
                <div><br /><br /><br /><br /><br /><br /></div>
                <div className={"text-center"}>
                    <button className={"btn btn-danger button-next btn-lg font-16"} onClick={(e) => this.moveToTest()}>Continue to diagnostic test</button>
                </div>
                <br /><br />
            </div>
        )

    }

    //Actions
    receiveNextFormNumber = (formSubmited) => {
        this.setState({formSubmited: formSubmited, collapsedForms: []});
        $(window).scrollTop(0);
    };
    onBasicInfoUpdate = (update) => {
        update.onboardingStep = 2;
        update.id = this.props.profile.id;
        this.props.updateProfile(update, this.props.user.id);
    };
    onContactsInfoUpdate = (update) => {
        update.onboardingStep = 2;
        update.id = this.props.profile.id;
        this.props.updateProfile(update, this.props.user.id);
    };
    
    onCourseUserUpdate = (update, cu) => {
        let profile = {...this.props.profile,
        id: this.props.profile.id, onboardingTest: update, onboardingStep: 5};

        this.props.updateCourseUser(profile, cu, this.props.user.id);
    }
    
    onEducationInfoUpdate = (update) => {
        let profile = {id: this.props.profile.id, education: [update], onboardingStep: 3};

        this.props.updateProfile(profile, this.props.user.id);
    };
    onCircumstancesInfoUpdate = (update) => {
        let profile = {id: this.props.profile.id, personal: update, onboardingStep: 4};

        this.props.updateProfile(profile, this.props.user.id);
    };
    onLsatInfoUpdate = (update) => {
        let profile = {id: this.props.profile.id, onboardingTest: update, onboardingStep: 5};

        this.props.updateProfile(profile, this.props.user.id);
    };

    lastFormClickBack = () => {
        let profile = {id: this.props.profile.id, onboardingStep: 6};

        this.props.updateProfile(profile, this.props.user.id);
    };

    finishOnboarding = () => {
        let profile = {id: this.props.profile.id, onboardingStep: 6};
        if(this.props.user.user.Profile.CourseUser[0]){
            if(this.props.user.user.Profile.CourseUser[0].officialTest){
                let test = this.props.user.user.Profile.CourseUser[0].officialTest;
                test.profileId = this.props.profile.id;
                test.courseId = this.props.user.user.Profile.CourseUser[0].courseId;
                this.props.addOfficialTest(test, this.props.user.id);
            }
        }

        if(!this.state.courseUser.Course.testId){
            profile.onboardingStep = 7;
            this.props.updateProfile(profile, this.props.user.id);
            let self = this;
            setTimeout(function(){
                //self.props.history.push('/dashboard');
            }, 1000);
            
        }else{
            this.props.updateProfile(profile, this.props.user.id);
        }

        
        

    }
    
    findError = () => {
        let self = this;
        setTimeout(function(){
        let scrolled = false;
        $('.form-section').each(function(section, index){
           let errors = $(this).find('.has-error');

           if($(errors)[0]){
               if(scrolled === false){
                   $([document.documentElement, document.body]).animate({
                        scrollTop: $(this).offset().top
                    }, 1000);
                    scrolled = true;
               }
               self.setState({collapsedForms: self.state.collapsedForms.concat(index + 1)});
           }
        });
        }, 1000);
    }
    

    //Renders
    renderForm1 = () => (
        <Form1
            onBasicInfoUpdate = {this.onBasicInfoUpdate}
            onContactsInfoUpdate = {this.onContactsInfoUpdate}
            parentProps = {this.props}
            // receivedValues={this.receiveValues}
            receiveNextFormNumber={this.receiveNextFormNumber}
            setPrevStep={this.setPrevStep}
            collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
        />
    );

    renderForm2 = () => (
        <Form2
            onEducationInfoUpdate = {this.onEducationInfoUpdate}
            parentProps = {this.props}
            stepNumber = {this.state.formSubmited}
            // receivedValues={this.receiveValues}
            receiveNextFormNumber={this.receiveNextFormNumber}
            setPrevStep={this.setPrevStep}
            collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
        />
    );

    renderForm3 = () => (
        <Form3
            parentProps = {this.props}
            onCircumstancesInfoUpdate={this.onCircumstancesInfoUpdate}
            // receivedValues={this.receiveValues}
            receiveNextFormNumber={this.receiveNextFormNumber}
            setPrevStep={this.setPrevStep}
            collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
        />
    );

    renderForm4 = () => {
        if(this.state.courseUser){
            return (
                <Form4
            onLsatInfoUpdate = {this.onLsatInfoUpdate}
            onCourseUserUpdate={this.onCourseUserUpdate}
            courseUser={this.state.courseUser}
            parentProps = {this.props}
            // receivedValues={this.receiveValues}
            receiveNextFormNumber={this.receiveNextFormNumber}
            setPrevStep={this.setPrevStep}
            collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
        />
                )
        }
    }
    
    renderReviewForm = () => {
        return (
            <div>
                <Review 
                    {...this.props} 
                    setStep={number => this.setSpecificStep(number)}
                />
                <div className="form-wizard" style={{paddingTop: '0px'}}>
                <div className="tab-content">
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <button className="btn btn-default btn-lg font-16 button-previous"
                                    onClick={this.setPrevStep}
                            >
                                <i className="m-icon-swapleft"/>
                                Back
                            </button>
                            &nbsp;

                            <button
                                className="btn btn-danger button-next btn-lg font-16"
                                onClick={this.finishOnboarding}
                            >
                                Continue
                                <i className="m-icon-swapright m-icon-white"/>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            </div>
            )
    }

    renderReviewFormOld = () => (
        <div>
            <Form1
                isReviewForm
                onBasicInfoUpdate = {this.onBasicInfoUpdate}
                onContactsInfoUpdate = {this.onContactsInfoUpdate}
                parentProps = {this.props}
                // receivedValues={this.receiveValues}
                receiveNextFormNumber={this.receiveNextFormNumber}
                updateProfile={this.updateProfile}
                collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
            />
            <Form2
                isReviewForm
                onEducationInfoUpdate = {this.onEducationInfoUpdate}
                parentProps = {this.props}
                // receivedValues={this.receiveValues}
                receiveNextFormNumber={this.receiveNextFormNumber}
                updateProfile={this.updateProfile}
                collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
            />
            <Form3
                isReviewForm
                parentProps = {this.props}
                onCircumstancesInfoUpdate={this.onCircumstancesInfoUpdate}
                // receivedValues={this.receiveValues}
                receiveNextFormNumber={this.receiveNextFormNumber}
                updateProfile={this.updateProfile}
                collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
            />
            <Form4
                isReviewForm
                onLsatInfoUpdate = {this.onLsatInfoUpdate}
                parentProps = {this.props}
                // receivedValues={this.receiveValues}
                receiveNextFormNumber={this.receiveNextFormNumber}
                updateProfile={this.updateProfile}
                collapsedForms={this.state.collapsedForms}
                collapseForm={this.collapseForm}
                clearCollapseForms={this.clearCollapseForms}
                toggleCollapse={this.toggleCollapse}
                findError={this.findError}
            />

            <div className="form-wizard">
                <div className="tab-content">
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <button className="btn btn-default btn-lg font-16 button-previous"
                                    onClick={this.setPrevStep}
                            >
                                <i className="m-icon-swapleft"/>
                                Back
                            </button>
                            &nbsp;

                            <button
                                className="btn btn-danger button-next btn-lg font-16"
                                onClick={this.finishOnboarding}
                            >
                                Continue
                                <i className="m-icon-swapright m-icon-white"/>
                            </button>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );

    renderTest = () => {
        if(this.state.courseUser){
        if(this.state.courseUser.Course.strategy) {
            if(this.state.courseUser.Course.strategy !== 'manual_strategy_active'){
                return (
                    
                    <TestContainer
                        testId={this.state.courseUser.Course.testId}
                        history={this.props.history}
                        match={this.props.match}
                        onboarding={true}
                    />
                    
                )
            }else{
                this.props.history.push('/dashboard');
                return null;
            }
        }else{
            // console.log("EMBED TEST!", this.state.courseUser.Course.testId);
            // Assuming there is a test?
            return (
                    
                <TestContainer
                    testId={this.state.courseUser.Course.testId}
                    history={this.props.history}
                    match={this.props.match}
                    onboarding={true}
                />
                
            )
            /*
            this.props.history.push('/dashboard');
            return null;
            
            return (
                <div className={"text-nocontent text-center"}>
                <h1>Diagnostic test doesn't exist for this course.</h1>
                    <button className={"btn btn-danger"} onClick={(e) => {
                        this.props.history.push('/dashboard');
                    }}>Go to dashboard</button>
                </div>
            )
            */
        }
    }else{
        return (
            <div></div>
        )
    }
}

    updateProfile = (data) => {

    }



    render() {

        if(this.props.profile.onboardingStep === 7){

            //this.props.history.push(`/test/${this.props.user.user.Profile.CourseUser[0].Course.testId}`);
            //this.props.history.push(`/dashboard`);
        }
        
        if(this.props.profile.onboardingStep === 7){
            return this.renderTest()
        }
        return (
            <div
                className="content-wrapper onboarding-page"
                id="content-container">
                <section className="content no-padding container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className={`panel no-bg form-onboarding-wrapper form-wizard ${this.state.formClass}`}
                                 id="form_wizard_1">
                                <div className="panel-body form no-bg on-board-form no-padding">
                                    <RegistrationSteps
                                        formNumber={this.props.profile.onboardingStep}
                                        scrollClass={this.state.scrollClass}
                                        setSpecificStep={this.setSpecificStep}
                                    />
                                    {
                                        this.props.profile.onboardingStep === 1
                                        && this.renderForm1()
                                    }
                                    {
                                        this.props.profile.onboardingStep === 2
                                        && this.renderForm2()
                                    }
                                    {
                                        this.props.profile.onboardingStep === 3
                                        && this.renderForm3()
                                    }
                                    {
                                        this.props.profile.onboardingStep === 4
                                        && this.renderForm4()
                                    }
                                    {
                                        this.props.profile.onboardingStep === 5
                                        && this.renderReviewForm()
                                    }
                                    {
                                        this.props.profile.onboardingStep == 6 &&
                                            this.renderHelpVideos()
                                    }
                                    {
                                        this.props.profile.onboardingStep == 7 &&
                                            this.renderTest()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

OnBoarding.propTypes = {
    onBasicInfoUpdate: PropTypes.func.isRequired,
    onContactsInfoUpdate: PropTypes.func.isRequired,
    onEducationInfoUpdate: PropTypes.func.isRequired,
    onCircumstancesInfoUpdate: PropTypes.func.isRequired,
    onLsatInfoUpdate: PropTypes.func.isRequired,
    infoCircumstances: PropTypes.object.isRequired,
    infoContacts: PropTypes.object.isRequired,
    infoEducation: PropTypes.object.isRequired,
    infoLSAT: PropTypes.object.isRequired
};



export default OnBoarding;



















// WEBPACK FOOTER //
// ./src/components/onBoarding/OnBoarding.js